import type {
  AccountSubjectReviewClass,
  AccountSubjectReviewDescriptor,
  AccountSubjectReviewItem,
  AccountSubjectReviewPage,
} from "@tabbio/types";
import { api } from "./api";
type Draft = { reference: string; statement: string };
export function updateSubjectReviewDraft(
  draft: Draft,
  event: { type: "failed" } | { type: "submitted"; reference: string },
): Draft {
  return event.type === "submitted" && event.reference === draft.reference
    ? { ...draft, statement: "" }
    : draft;
}
export function subjectReviewCanRequest(input: {
  enabled: boolean;
  selected: boolean;
  statement: string;
}) {
  return (
    input.enabled &&
    input.selected &&
    input.statement.trim().length >= 10 &&
    input.statement.trim().length <= 1000
  );
}
export async function readSubjectReviewQueue(cursor?: string) {
  const response = await api.get<AccountSubjectReviewPage>(
    `/api/account/subject-reviews${cursor ? `?cursor=${encodeURIComponent(cursor)}` : ""}`,
    { cache: "no-store" },
  );
  if (response.error || !response.data)
    throw new Error(response.error?.message ?? "SUBJECT_REVIEW_UNAVAILABLE");
  return response.data;
}
export async function readSubjectReviewCandidates(
  sourceClass: AccountSubjectReviewClass,
  cursor?: string,
) {
  const query = new URLSearchParams({
    sourceClass,
    ...(cursor ? { cursor } : {}),
  });
  const response = await api.get<{
    items: AccountSubjectReviewDescriptor[];
    next: string | null;
  }>(`/api/account/subject-reviews/candidates?${query}`, { cache: "no-store" });
  if (response.error || !response.data)
    throw new Error(response.error?.message ?? "SUBJECT_REVIEW_UNAVAILABLE");
  return response.data;
}
export async function requestSubjectReview(
  reference: AccountSubjectReviewDescriptor,
  statement: string,
) {
  const response = await api.post<AccountSubjectReviewItem>(
    "/api/account/subject-reviews",
    { sourceClass: reference.sourceClass, keys: reference.keys, statement },
  );
  if (response.error || !response.data)
    throw new Error(response.error?.message ?? "SUBJECT_REVIEW_UNAVAILABLE");
  return response.data;
}
